import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendUser } from 'src/types/backend';

const MUTATION = gql`
  mutation SendRegistrationConfirmation {
    sendRegistrationConfirmation {
      id
    }
  }
`;

type Result = Pick<BackendUser, 'id'>;

export const sendRegistrationConfirmation = async () => {
  const result = await executeGqlMutation({ mutation: MUTATION });
  return getSingleProp<Result>(result.data);
};
